import {Controller} from "@hotwired/stimulus"
import {Modal} from "bootstrap"

export default class extends Controller {


    connect() {
        const form = this.element;
        const formData = new FormData(form);
        const url = new URL(window.location.href);
        const params = new URLSearchParams(formData);
        params.forEach((value, key) => {
            let val = url.searchParams.get(key)
            if (val) {
                document.getElementById(key).value = val;
            }
        })
    }

    submit(e) {
        // console.log("submit")
        const form = this.element;
        const formData = new FormData(form);
        const url = new URL(window.location.href);
        const params = new URLSearchParams(formData);

        params.forEach((value, key) => {
            if (url.searchParams.get(key)) {
                if (value) {
                    url.searchParams.set(key, value);
                } else {
                    url.searchParams.delete(key);
                }
            } else {
                if (value) {
                    url.searchParams.set(key, value);
                }
            }
            // console.log(url.searchParams)
        });
        // submit(e) {
        //     // console.log("submit")
        //     const form = this.element;
        //     const formData = new FormData(form);
        //     const url = new URL(window.location.href);
        //     const params = new URLSearchParams(formData);
        //
        //     params.keys().forEach(( key) => {
        //         console.log(key);
        //         let values = params.getAll(key)
        //         console.log()
        //         if (url.searchParams.get(key)) {
        //             if (values) {
        //                 url.searchParams.set(key, values);
        //             } else {
        //                 url.searchParams.delete(key);
        //             }
        //         } else {
        //             if (values) {
        //                 console.log(key, values);
        //                 url.searchParams.set(key, values);
        //             }
        //         }
        //     });

        //
        //
        // const newUrl = `${form.action}?${params.toString()}`;

        // Turbo.visit(newUrl, { frame: "jobs" });

        // history.pushState({}, "", url);
        //
        const ddn = new bootstrap.Dropdown(e.target.parentNode.parentNode);
        ddn.hide();
        Turbo.visit(url, {action: "advance"});
        e.preventDefault();
    }

}